import React from "react";

const convertirBufferATexto = (valor) => {
  if (valor?.type !== "Buffer" || !Array.isArray(valor.data)) {
    return valor;
  }

  return Buffer.from(valor.data).toString("utf-8");
};

const Select = (props) => {
  let {
    nombre,
    opciones,
    onChange,
    onBlur,
    value,
    def,
    disabled,
    loading = false,
  } = props;
  const validValue = opciones.find((op) => op.value == value);
  if (!validValue) {
    value = null;
  }

  const isDisabled =
    disabled === true || disabled === "true" || disabled === "s";
  const hasOptions = opciones.length > 0;
  const selectValue = loading ? 1 : hasOptions ? value ?? def : "";
  const className = [
    "tarjeta_grid_item_select",
    "select_listado",
    isDisabled ? "input-disabled" : "",
    props.className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <select
        name={nombre}
        value={selectValue}
        onChange={onChange}
        onBlur={onBlur}
        // defaultValue={def}
        className={className}
        disabled={isDisabled}
      >
        {loading ? (
          <option value={1}>Cargando opciones ...</option>
        ) : !hasOptions ? (
          <option value="" disabled>
            -Sin opciones-
          </option>
        ) : (
          opciones.map((op) => {
            return (
              <option
                key={op.value?.toString()}
                value={op.value}
                disabled={op.disabled}
                className="select_listado_opciones"
              >
                {convertirBufferATexto(op.label)}
              </option>
            );
          })
        )}
      </select>
      {/* {loading ? (
        <span
          style={{
            fontSize: "0.5rem",
            color: "red",
            position: "absolute",
            bottom: "0",
            right: "5%",
          }}
        >
          * Cargando opciones ...
        </span>
      ) : (
        <></>
      )} */}
    </>
  );
};

export default Select;
